import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyModule } from '@ngx-formly/core';
import { TableV3Component } from '@gea/digital-ui-lib';
import { CheckboxRendererComponent } from './CheckboxRenderer';

@Component({
  selector: 'formly-geaui-table-v3',
  imports: [ReactiveFormsModule, FormlyModule, TableV3Component],
  template: `
    <geaui-table-v3
      [tableId]="'storybook'"
      [selectionMode]="'single'"
      [columnDefinitions]="columnDefinitions"
      [data]="props['data']"
      (selectionChange)="handleSelectionChange($event)"></geaui-table-v3>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeaUiTableV3TypeComponent extends FieldType<FieldTypeConfig> {
  get formGroup(): FormGroup {
    return this.form as FormGroup;
  }

  get columnDefinitions() {
    const checkmarkColumnDefinition = {
      displayName: 'Select',
      key: 'checkmark',
      minWidth: 150,
      renderer: { component: CheckboxRendererComponent },
    };

    // Ensure props['columns'] is an array (default to empty array if undefined).
    const columns = this.props['columns'] || [];
    return [checkmarkColumnDefinition, ...columns];
  }

  handleSelectionChange(selection: any): void {
    console.log('New selection: ', selection);
  }

  override defaultOptions = {
    className: 'fullWidthComponent',
  };
}
